// Archivo para manejar el formulario de creación de consumidores
import React from 'react'
import PropTypes from 'prop-types'
import { Box, TextField } from '@mui/material'

const ConsumerForm = ({ onChange }) => {
  const [form, setForm] = React.useState({
    full_name: '',
    phone: '',
    email: '',
  })

  const handleChange = (field, value) => {
    const updated = { ...form, [field]: value }
    setForm(updated)
    onChange(updated)
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
      <TextField
        label="Nombre completo"
        value={form.full_name}
        onChange={(e) => handleChange('full_name', e.target.value)}
        fullWidth
        required
      />
      <TextField
        label="Teléfono"
        value={form.phone}
        onChange={(e) => handleChange('phone', e.target.value)}
        fullWidth
      />
      <TextField
        label="Correo electrónico"
        value={form.email}
        onChange={(e) => handleChange('email', e.target.value)}
        fullWidth
      />
    </Box>
  )
}

ConsumerForm.propTypes = {
  onChange: PropTypes.func.isRequired,
}

export default ConsumerForm
